import { Box, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import { ArrowForward } from '@mui/icons-material';

import { StepComponentProps } from 'components/Flow/RenderMachine';
import { grayish, lighterGray, mediumGray } from 'utils/color-styles';
import SplashWrapper from 'retired/SplashWrapper';
import chapterIcon from 'assets/onboarding/organizationTypes/chapter.svg';
import govIcon from 'assets/onboarding/organizationTypes/gov.svg';
import membershipIcon from 'assets/onboarding/organizationTypes/membership.svg';
import nonUSIcon from 'assets/onboarding/organizationTypes/nonUS.svg';
import nonprofitIcon from 'assets/onboarding/organizationTypes/nonprofit.svg';
import schoolIcon from 'assets/onboarding/organizationTypes/school.svg';
import restIcon from 'assets/onboarding/organizationTypes/rest.svg';
import Img from 'retired/Img';

import { Breadcrumbs } from './Components/Breadcrumbs';

const Option = ({
  title,
  subTitle,
  icon,
  onClick,
}: {
  title: ReactNode;
  subTitle: ReactNode;
  icon: string;
  onClick: () => void;
}) => (
  <Box
    onClick={onClick}
    bgcolor={lighterGray}
    borderRadius={2}
    p={3}
    border={`1px solid ${mediumGray}`}
    style={{ cursor: 'pointer' }}
  >
    <Box display="flex" alignItems="center" height="100%">
      <Img src={icon} width={80} height={80} style={{ marginRight: 16 }} />
      <Box flexGrow={1}>
        <Typography fontSize={14} mb={1}>
          {title}
        </Typography>
        <Typography fontSize={12} color={grayish}>
          {subTitle}
        </Typography>
      </Box>
      <ArrowForward style={{ alignSelf: 'center' }} />
    </Box>
  </Box>
);

export const OrganizationTypeSelection = ({ send }: StepComponentProps) => (
  <SplashWrapper fullWidth>
    <Box bgcolor="white" display="flex" flexDirection="column" height="calc(100vh - 126px)">
      <Box
        flexGrow={1}
        flexShrink={1}
        style={{
          overflowY: 'auto',
        }}
      >
        <Typography fontSize={16} fontWeight={500} mb={4} ml={3}>
          What type of entity is your organization?
        </Typography>
        <Box flexGrow={1}>
          <Box
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              rowGap: 24,
              columnGap: 96,
            }}
          >
            <Option
              onClick={() => send('OPTION_CHAPTER')}
              icon={chapterIcon}
              title={
                <>
                  Are you <strong style={{ fontWeight: 500 }}>a Chapter or fiscal sponsee</strong>{' '}
                  of a 501(c)(3) charitable organization?
                </>
              }
              subTitle="Identify if your organization operates as a local chapter of a larger nonprofit."
            />
            <Option
              onClick={() => send('OPTION_501C3')}
              icon={nonprofitIcon}
              title={
                <>
                  Are you{' '}
                  <strong style={{ fontWeight: 500 }}>a 501(c)(3) charitable organization?</strong>
                </>
              }
              subTitle="Registered 501c3 organizations with IRS tax-exempt status."
            />
            <Option
              onClick={() => send('OPTION_GOV')}
              icon={govIcon}
              title={
                <>
                  Are you <strong style={{ fontWeight: 500 }}>a Government entity</strong> that is
                  not a 501(c)(3) charitable organization?
                </>
              }
              subTitle="Non-501c3 entities representing federal, state, or local government."
            />
            <Option
              onClick={() => send('OPTION_SCHOOL')}
              icon={schoolIcon}
              title={
                <>
                  Are you{' '}
                  <strong style={{ fontWeight: 500 }}>
                    a School that is not a 501(c)(3) charitable organization?
                  </strong>
                </>
              }
              subTitle="Public, private, charter schools or colleges."
            />
            <Option
              onClick={() => send('OPTION_MEMBERSHIP')}
              icon={membershipIcon}
              title={
                <>
                  Are you{' '}
                  <strong style={{ fontWeight: 500 }}>
                    a Other Nonprofit Membership Organization (501(c)(4), 501(c)(6), or 501(c)(19)
                    nonprofit organization)?
                  </strong>
                </>
              }
              subTitle="Organizations with an EIN but Without Tax-Exempt Status."
            />
            <Option
              onClick={() => send('OPTION_NON_US')}
              icon={nonUSIcon}
              title="Are you an international organization outside of the US?"
              subTitle=""
            />
            <Option
              onClick={() => send('OPTION_REST')}
              icon={restIcon}
              title="None of the above?"
              subTitle=""
            />
          </Box>
        </Box>
      </Box>
      <Breadcrumbs send={send} title="Entity type" />
    </Box>
  </SplashWrapper>
);
